angular.module('autoremind.communications')
    .directive('targetForm', ['jobService', function (jobService) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, elem, attrs) {
                scope.$watch(attrs.name + '.$valid', function (newState, oldState) {
                    jobService.job.isValid = newState;
                });
            }
        };
    }]);
//# sourceMappingURL=target.directives.js.map